export default __webpack_public_path__ + "static/media/getintouch.1685ef95.svg";